/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2021-02-01 14:05:45
 */
import React, { Component } from 'react';
import { HotKeys } from 'react-hotkeys';
import { keyMap } from './config/tableKeyboardMap';
import { createByModuleType, deleteKeyByModuleId } from './createKeyMap';
import { keyDownOfShiftUp, handleArrowKeyDown } from './handleKeyDown';
import { stopCardTableHotKeyChange } from './config/stopHotKeyChange';
import { findNextFocusItemInTable } from './util/findNextFocusItemInTable';

function TableWithKeyboardChange(WrappedComponent) {
    return class WithKeyboardChange extends Component {
        constructor(props) {
            super(props);
        }

        componentDidUpdate(nextProps) {
            if (stopCardTableHotKeyChange(this.props)) { return; }

            createByModuleType['table'](this.props);
        }

        componentWillUnmount() {
            // 部分情况下KeyByModuleId 没有清除  导致创建不能直接聚焦
            deleteKeyByModuleId(this.props.moduleId || this.props.name);
        }

        static tableStatusChanged({ props, status }) {
            if (status === 'edit' && !stopCardTableHotKeyChange(props)) {
                createByModuleType['table'](props);
            } else {
                deleteKeyByModuleId(props.moduleId);
            }

        }

        hotKeyWithEnter = ({ e, ViewModel, moduleId, target, itemType }) => {
            let eventTarget = target || e.target;
            let { orderOfHotKey } = this.props.getHotKeyConfig ? this.props.getHotKeyConfig() : {};
            if (!orderOfHotKey) {
                console.warn('not find orderOfHotKey in getHotKeyConfig')
                return;
            }

            //日期类型延迟执行时eventTarget已被移出document导致寻找不到父元素td,所以日期类型立即执行
            if (itemType === 'datePicker') {
                findNextFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
                return;
            }

            //CLOUD-147579 中文输入法下会带进冒号空格等符号，原因是因为输入法的enter比我们的enter后执行导致
            let timer = setTimeout(() => {
                findNextFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
                clearTimeout(timer);
            });
        };

        hotKeyWithArrow = ({ e, ViewModel, moduleId, itemType, target }) => {
            let eventTarget = target || e.target;
            let { orderOfHotKey } = this.props.getHotKeyConfig ? this.props.getHotKeyConfig() : {};
            if (!orderOfHotKey) {
                console.warn('not find orderOfHotKey in getHotKeyConfig')
                return;
            }

            handleArrowKeyDown({
                eventTarget,
                ViewModel,
                moduleId,
                orderOfHotKey,
                itemType,
                keyCode: e.keyCode,
            });
        };

        render() {
            return (
                <HotKeys
                    keyMap={keyMap}
                    handlers={{
                        shiftUp: keyDownOfShiftUp.bind(this, this.props.tableId || this.props.name),
                        shiftDown: keyDownOfShiftUp.bind(this, this.props.tableId || this.props.name),
                    }}
                >
                    <WrappedComponent
                        {...this.props}
                        tableStatusChanged={WithKeyboardChange.tableStatusChanged}
                        hotKeyWithEnter={this.hotKeyWithEnter}
                        hotKeyWithArrow={this.hotKeyWithArrow}
                    />
                </HotKeys>
            );
        }
    };
}

export default TableWithKeyboardChange;
